import { Store } from 'pullstate';

export const SessionStore = new Store<{ user?: API.User }>({});
